export const FeatureFlagsNames = {
  /** Allows certain users to access New Portal & Tracker 2025 pilot on production */
  showTrackerPilot: 'portal_pilot_11_2025',
  /** Used in Continue E-App menu where we allow certain users to see the Firelight SSO button */
  showFirelightSso: 'firelight_sso',
  /** Used in integrations settings where we allow certain users to connect their Lifecycle data to Redtail */
  showRedtailLifecycle: 'redtail_lifecycle',
  /** Allows certain users full access to the New Portal pilot 2026 */
  showNewPortal: 'portal_pilot_02_2026',
};